<template>
  <sl-page>
    <div class='page-filter'>
      <Row :gutter="12">
        <Col span="8" :lg="8" :md="8" :sm="12" :xs="24" class="margin-bottom">
        <Input v-model="params.versionNo" placeholder="请输入版本号"></Input>
        </Col>
        <Col span="8" :lg="8" :md="8" :sm="12" :xs="24" class="margin-bottom">
        <sl-select v-model="params.terminal" dict="$appPlatform" placeholder="请选择平台类型" />
        </Col>
        <Col span="8" :lg="8" :md="8" :sm="24" :xs="24" class="page-action">
        <div>
          <Button type="primary" icon="ios-search" @click="list()">搜索</Button>
          <Button icon="ios-reset" @click="reset()">清空</Button>
        </div>
        <div>
          <Button type="primary" icon="md-add" @click="create()">新增</Button>
        </div>
        </Col>
      </Row>
    </div>
    <div class="pg-bd">
      <sl-table ref="table" :show-header="false" :loading="loading" :page="page" :columns="columns" :data="data" @on-selection-change="handleSelect" @on-update="handleChange"></sl-table>
    </div>
    <app-ver-item ref="item" @on-update="handleUpdate" />
  </sl-page>
</template>
<script>
import appVerItem from './detail'
import appListItem from './item'

const columns_ = [{
    title: 'APP名称',
    key: 'applicationTitle',
    minWidth: 150,
    render:(h , {row}) => {
      return h(appListItem , { props:{ data : row} } )
    }
  },
  // {
  //   title: '平台类型',
  //   key: 'terminalText',
  //   minWidth: 100,
  // },
  // {
  //   title: '版本号',
  //   key: 'versionNo',
  //   minWidth: 100,
  // },
  // {
  //   title: '更新时间',
  //   key: 'releaseDatetimeText',
  //   minWidth: 150,
  // },
  // {
  //   title: '发布状态',
  //   key: 'publishDisplay',
  //   minWidth: 120,
  // },
]

const publishDisplay = (d) => {
  return d.isVisible ? '已发布' : '待发布'
}
export default {
  components: { appVerItem },
  data() {
    return {
      columns: [
        ...columns_,
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'left',
          render: (h, params) => {
            //是否发布 ：0：未发布,1：发布

            return h('div', [
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.edit(params)
                  }
                }
              }, '编辑'),
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.toggle(params)
                  }
                }
              }, params.row.isVisible ? '取消发布' : '发布')
            ])
          }
        }
      ],
      data: [],
      params: {
        versionNo: null,
        terminal: null,
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      selection: []
    }
  },
  computed: {
    removeDisable() {
      return this.selection.length == 0
    }
  },
  created() {
    this.def = { ...this.params }
    this.list()
  },

  methods: {

    list() {
      let params = { search: { ...this.params }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.appVers(params).then(resp => {
        console.log(resp)
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data.list || [], { 'releaseDatetime': 'datetime', publishDisplay, 'modifyDatetime':'datetime' ,terminal: 'appPlatform' })
          this.page.total = resp.data.total || 0
        }
      })
    },

    edit({ row }) {
      this.$refs['item'].init(row.id)
    },

    create() {
      this.$refs['item'].init(0)
    },

    remove({ row }) {
      this.$ui.confirm(this.$request.carCateDelete, `确定删除 ${row.name} ？`)(row.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.selection = []
          this.list()
        } else {
          this.$Notice.error({
            title: '删除发生错误',
            desc: resp.msg,
          });
        }
      })
    },

    toggle({ row }) {
      let tip = '确定' + (row.isVisible ? '取消发布' : '发布') + `${row.applicationTitle}(v${row.versionNo}) ?`
      this.$ui.confirm(this.$request.appVerToggle, tip)(row.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.selection = []
          this.list()
        } else {
          this.$Notice.error({
            title: '发生错误',
            desc: resp.msg,
          });
        }
      })
    },

    reset() {
      this.$utils.fill(this.params, this.def)
      this.list()
    },

    handleUpdate() {
      this.modalVisible = false
      this.list()
    },

    handleChange(pageNum, pageSize) {
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.list()
      }
    },

    handleSelect(selection) {
      this.selection = selection.map(i => i.id)
    }
  }
}

</script>
